// extracted by mini-css-extract-plugin
export default {"description":"insufficientPaymentFailPopup_description__ayooK","reason":"insufficientPaymentFailPopup_reason__6yQDv"};